import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function CircularIndeterminate() {
	const loadingData = 'inProgress';
	return (
		<Box sx={{ display: 'flex', alignItems: 'center' }}>
			<CircularProgress />
		</Box>
	);
}
